import type { ProductWith } from '@scayle/storefront-nuxt'
import { sustainabilityAttributes } from '../utils/sustainability'

export const PRODUCTS_PER_PAGE = 60
export const MINIMUM_QUANTITY_IMMEDIATE_AVAILABILITY = 5
export const PRODUCT_WITH_PARAMS: ProductWith = {
  attributes: {
    withKey: [
      'colorRange',
      'colorHex',
      'color',
      'brand',
      'name',
      'size_note',
      ...sustainabilityAttributes,
      'premiumsegment',
    ],
  },
  variants: {
    attributes: {
      withKey: ['price', 'sizeCategory'],
    },
  },
  siblings: {
    attributes: {
      withKey: ['colorRange', 'colorHex', 'color', 'brand', 'name'],
    },
  },
  images: {
    attributes: {
      withKey: [
        'assetType',
        'imageType',
        'imageView',
        'imageBackground',
        'imageKind',
      ],
    },
  },
  priceRange: true,
  categories: {
    properties: {
      withName: ['baseCategories'],
    },
  },
}

export const SEARCH_PRODUCT_WITH_PARAMS: ProductWith = {
  attributes: {
    withKey: [
      'colorRange',
      'colorHex',
      'brand',
      'name',
      'color',
      'premiumsegment',
    ],
  },
  variants: {
    attributes: {
      withKey: ['price', 'size', 'sizeCategory'],
    },
  },
  images: {
    attributes: {
      withKey: [
        'assetType',
        'imageType',
        'imageView',
        'imageBackground',
        'imageKind',
      ],
    },
  },
  categories: {
    properties: {
      withName: ['categoryName'],
    },
  },
  siblings: {
    images: {
      attributes: {
        withKey: ['imageType', 'imageView', 'imageBackground'],
      },
    },
    attributes: {
      withKey: ['colorRange', 'colorHex', 'name', 'brand', 'color'],
    },
  },
  priceRange: true,
}

/**
 * Product with only the details of the product
 * Does not include siblings
 */
export const PRODUCT_ONLY_DETAILS_WITH: ProductWith = {
  attributes: {
    withKey: [
      'articleType',
      'color',
      'colorHex',
      'colorRange',
      'brand',
      'name',
      'brandLogo',
      'shoeMaterialStyle',
      'fastenerType',
      'materialStyle',
      'necklineStyle',
      'design',
      'extras',
      'material',
      'fitting',
      'upperLength',
      'sleeveLength',
      'shirtCut',
      'bottomLength',
      'trousersCut',
      'careSymbol',
      'elasticity',
      'knitMaterialType',
      'sportType',
      'washComment',
      'isQuantityChangeDisabled',
      'recommendations',
      'caresymbolWash',
      'caresymbolBleaching',
      'caresymbolDry',
      'caresymbolIron',
      'caresymbolClean',
      'articleFeatureIcon',
      'directOrder',
      'mainOrderNumberList',
      'sizeNote'
    ],
  },
  advancedAttributes: {
    withKey: [
      'articlePlacement',
      'materialCompositionTextile',
      'longdescription',
      'sellingPoint1Dessin',
      'sellingPoint2Material',
      'sellingPoint3AGSSpezialDetail',
      'sellingPoint4InternEinkauf',
      'material',
      'mainOrderNumber',
      'ordernumber',
    ],
  },
  variants: {
    attributes: {
      withKey: [
        'sizeCategory',
        'sizeCategorySize',
        'price',
        'size',
        'erpSizeKey',
        'restockDate',
        'productOrderNumber',
        'productOrderNumberList',
      ],
    },
    advancedAttributes: {
      withKey: ['measures'],
    },
  },
  images: {
    attributes: {
      withKey: ['imageType', 'imageView', 'imageBackground', 'assetType'],
    },
  },
  categories: {
    properties: 'all' as const,
    countryLevelCustomData: true,
  },
  priceRange: true,
}

/**
 * Product with details of the product
 * Includes basic sibling details
 */
export const PRODUCT_DETAILS_WITH: ProductWith = {
  ...PRODUCT_ONLY_DETAILS_WITH,
  siblings: {
    images: {
      attributes: {
        withKey: [
          'imageType',
          'imageView',
          'imageBackground',
          'frameColor',
          'assetType',
        ],
      },
    },
    attributes: {
      withKey: [
        'color',
        'colorHex',
        'colorRange',
        'name',
        'brand',
        'premiumsegment',
        'directOrder',
        'mainOrderNumberList',
        'ordernumber',
        'sizeNote'
      ],
    },
    advancedAttributes: {
      withKey: ['ordernumber', 'articlePlacement'],
    },
    variants: {
      attributes: {
        withKey: [
          'sizeCategory',
          'sizeCategorySize',
          'price',
          'size',
          'erpSizeKey',
          'restockDate',
          'productOrderNumber',
          'productOrderNumberList',
        ],
      },
      advancedAttributes: {
        withKey: ['measures'],
      },
    },
  },
  priceRange: true,
}

/**
 * Product with details of the product
 * Includes full sibling details
 */
export const PRODUCT_SIBLINGS_DETAILS_WITH: ProductWith = {
  ...PRODUCT_ONLY_DETAILS_WITH,
  siblings: PRODUCT_ONLY_DETAILS_WITH,
}
